/**
 * Single product: links that open a WooCommerce tab (data-smx-open-tab="<tab id>"),
 * e.g. "Vedi prodotti in sostituzione" -> "Sostituzioni" tab. A URL hash
 * "#tab-<tab id>" opens the tab on page load as well.
 */
function openTab(tabId, scroll) {
	const title = document.querySelector(`#tab-title-${tabId} a`);
	const panel = document.getElementById(`tab-${tabId}`);
	if (!title || !panel) {
		return false;
	}

	// WooCommerce tabs handler (single-product.js) shows the panel.
	title.click();

	if (scroll) {
		const tabs = panel.closest(".woocommerce-tabs") || panel;
		const header = document.getElementById("main-header");
		const offset = (header ? header.offsetHeight : 0) + 16;
		window.scrollTo({ top: tabs.getBoundingClientRect().top + window.scrollY - offset, behavior: "smooth" });
	}

	return true;
}

function init() {
	document.addEventListener("click", (event) => {
		const link = event.target.closest("[data-smx-open-tab]");
		if (link && openTab(link.dataset.smxOpenTab, true)) {
			event.preventDefault();
		}
	});

	const match = window.location.hash.match(/^#tab-([\w-]+)$/);
	if (match) {
		// After WooCommerce has initialised the tabs.
		window.setTimeout(() => openTab(match[1], true), 0);
	}
}

export default { init };
